/* istanbul ignore file */
// eslint-disable-next-line simple-import-sort/imports
import '../scripts/wdyr';
import React from 'react';
import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import { setLocaleCookies } from '@noths/polaris-client-localisation';
import { BaseApp, BaseAppProps } from '@noths/polaris-client-next-components';
import { SkipLinks, SmartAppBanner } from '@noths/polaris-client-site-chrome-ui';
import { AppContextPlusCookies } from '@noths/polaris-dev-ts-types';
import NextApp, { AppInitialProps, AppProps } from 'next/app';
import getConfig from 'next/config';
import Head from 'next/head';

import { fetchGlobalContent } from 'src/services/contentstack';
import { SKIP_CONTENT_TARGET_ID } from '../constants/elementIds';

const config = getConfig();
const AppComponent = BaseApp(config);

const App = (props: AppProps & BaseAppProps) => (
  <>
    <Head>
      <SmartAppBanner />
    </Head>
    <SkipLinks links={[{ content: 'Skip to content', sectionId: SKIP_CONTENT_TARGET_ID }]} />
    <AppComponent {...props} />
  </>
);

App.getInitialProps = async (
  appContext: AppContextPlusCookies,
): Promise<AppInitialProps & BaseAppProps> => {
  const {
    router,
    ctx: { req, res },
  } = appContext;

  if (req && res) {
    setLocaleCookies({ req, res });
  }

  const featureFlags = (req && getFeatureFlags(req)) || {};
  const appProps = await NextApp.getInitialProps(appContext);

  if (router.route === '/404') {
    const [navData] = await fetchGlobalContent({ featureFlags });

    return {
      ...appProps,
      navData,
      featureFlags,
    };
  }

  return { ...appProps, featureFlags };
};

export default App;
